import axios from 'axios'
import {defineStore} from 'pinia'
import { notifyNativeAppOfAddToCart } from '../helpers/venn-apps'

export const useCartStore = defineStore('CartStore', {
  state: () => {
    return {
      cart: {
        loading: true,
        items: []
      },
      cartIsUpdating: false,
      slideoutCartIsOpen: false
    }
  },
  actions: {
    async getCart() {
      document.addEventListener('cartRefresh', event => {
        if (event.detail.token) {
          this.cart = event.detail
          this.cartIsUpdating = false
        }
      })
      await axios.get(window.Shopify.routes.root + 'cart.js').then(async response => {
        this.cart = response.data
        this.cartIsUpdating = false
      })
    },
    async addItems(payload) {
      this.cartIsUpdating = true
      await axios.post(window.Shopify.routes.root + 'cart/add.js', payload)
        .then(async addResponse => {
          document.dispatchEvent(new Event('cartItemAdded'))
          console.log(
            `items added to your cart:`,
            addResponse.data.items
          )
          notifyNativeAppOfAddToCart(payload.items)
        })
        .catch((e) => {
          alert(e.response.data.description)
          console.error(e)
        })
    },
    async changeItems(payload) {
      await this.processChange(payload, 'change')
    },
    async clearCart() {
      await this.processChange(false, 'clear')
    },
    async updateItems(payload) {
      await this.processChange(payload, 'update')
    },
    async removeItem(key) {
      await this.changeItems({
        id: key,
        quantity: 0
      })
    },
    async processChange(payload, endpoint) {
      this.cartIsUpdating = true
      await axios.post(`${window.Shopify.routes.root}cart/${endpoint}.js`, payload)
        .then(async response => {
          this.cart = response.data
          this.cartIsUpdating = false
          document.dispatchEvent(new Event('cartUpdated'))
        })
        .catch((e) => {
          alert(e.response.data.message)
          console.log(e)
          this.cartIsUpdating = false
        })
    },

    openSlideoutCart() {
      this.slideoutCartIsOpen = true
      document.body.classList.add('overflow-hidden')
    },

    closeSlideoutCart(event) {
      if (event.target.hasAttribute('data-close')) {
        this.slideoutCartIsOpen = false
        document.body.classList.remove('overflow-hidden')
      }
    }
  },

  getters: {
    items() {
      if (this.cart) {
        return this.cart.items.filter(item => {
          return !((item.discounts.find(discount => discount.title === window.theme.cart.freeGift.discountScriptTitle)) ||
            (item.properties && item.properties.bundle))
        })
      } else {
        return []
      }
    },
    bundleItems() {
      if (this.cart) {
        return this.cart.items.filter(item => {
          return item.properties && item.properties.bundle
        })
      } else {
        return []
      }
    },
    itemCount() {
      let amount = 0
      if (this.cart) {
        this.items.forEach(item => {
          amount += item.quantity
        })
      }
      return amount
    },
    totalPrice() {
      return this.cart ? this.cart.total_price : 0
    },
    cartIsEmpty() {
      return this.itemCount === 0
    },
    cartContainsFreeGift() {
      return !!this.cart.items.find(item => {
        return !!item.discounts.find(discount => discount.title === window.theme.cart.freeGift.discountScriptTitle)
      })
    },
    freeGiftItem() {
      if (this.cartContainsFreeGift) {
        return this.cart.items.find(item => {
          return !!item.discounts.find(discount => discount.title === window.theme.cart.freeGift.discountScriptTitle)
        })
      }
      return null
    },
    freeGiftDeliveryExceptionProducts() {
      return [...window.theme.cart.freeGift.deliveryExceptionProducts]
    },
    cartContainsNoneExcemptItems() {
      let noneExcemptProductFound = false
      this.items.forEach(item => {
        if (!this.freeGiftDeliveryExceptionProducts.find(product => product.handle === item.handle)) {
          noneExcemptProductFound = true
          return
        }
      })
      return noneExcemptProductFound
    }
  },
})
